// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"43":"e951e4f4","361":"cfc1fa08","401":"0f5500d6","602":"e951e4f4"}[chunkId] + ".chunk.css";
};